import React from 'react';

import { KeyboardBackspace } from '@mui/icons-material';
import { Box } from '@mui/system';
import ZendeskButton from 'src/components/Zendesk/ZendeskButton';

import NavBarLayout from '../NavBarLayout';

/**
 * Holds needed data and functionality to power the zip code modal feature in menu page (as of 04/22)
 */
export interface ZipCode {
  cartZipCode: string;
  setZipCodeModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
interface Props {
  cartNode?: React.ReactNode;
  handleUnsavedChanges?: () => void;
  zipCode?: ZipCode;
}

const FunnelNavBarHeader: React.FC<Props> = ({
  cartNode,
  handleUnsavedChanges,
  zipCode,
}) => {
  return (
    <NavBarLayout
      zipCode={zipCode}
      leftComponent={
        handleUnsavedChanges ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            <KeyboardBackspace
              sx={{ cursor: 'pointer' }}
              color="primary"
              fontSize="medium"
              onClick={(ev) => {
                ev.preventDefault();
                handleUnsavedChanges && handleUnsavedChanges();
              }}
            />
            <ZendeskButton iconOnly />
          </Box>
        ) : (
          <ZendeskButton iconOnly />
        )
      }
      rightComponent={cartNode}
      position={'fixed'}
    />
  );
};

export default FunnelNavBarHeader;
